module.exports = obj => Array.prototype.slice.call(obj);
